import { useMemo as r } from "react";

const e = (e, t, n) => {
    /*
          For some reason was done with useState + useEffect, should work ok with useMemo
      */
    const o = r((() => {
        if (!n) return !1;
        try {
            const r = ((r, e) => {
                const {fields: t} = r.describe();
                if (!t) return;
                if (!e.includes(".")) return t[e];
                let n = e.split("."), o = t, s = 0, i = n.length - 1;
                for (;s < i; s++) if (o = o?.[n[s]]?.fields, void 0 === o) return o;
                return o[n[s]];
            })(n, e);
            /*
                      Field may be unitialized sometimes.
                  */            return !!r && r.tests.some((r => "required" === r.name))
            /*
                      Originally it was .find, but 'isRequired' naming makes me think, that 'some' is better.
                  */;
        } catch (r) {
            return "production" !== process.env.NODE_ENV && (console.warn("Error in useFormikSchema:"), 
            console.log(r)), !1;
        }
    }), [ e, n ]);
    return {
        isRequired: o,
        formattedLabel: o ? `${t}*` : t
    };
};

export { e as default };
//# sourceMappingURL=index.js.map
